import { inject } from 'inversify';
import { Injectable } from '../../decorators/injectable';
import { HttpService, type IHttpService } from '../http/http.service';
import type {
  INotificationService,
  NotificationItem,
  NotificationListParams,
  NotificationListResponse,
} from './notification.service.interface';

@Injectable()
export class NotificationService implements INotificationService {
  constructor(@inject(HttpService) private readonly http: IHttpService) {}

  async getNotifications(params: NotificationListParams = {}): Promise<NotificationListResponse> {
    const search = new URLSearchParams();
    if (params.category) {
      search.set('category', params.category);
    }
    if (params.unreadOnly) {
      search.set('unreadOnly', 'true');
    }
    if (params.from) {
      search.set('from', params.from);
    }
    if (params.to) {
      search.set('to', params.to);
    }
    if (params.page) {
      search.set('page', String(params.page));
    }
    if (params.pageSize) {
      search.set('pageSize', String(params.pageSize));
    }
    const qs = search.toString();
    return this.http.get<NotificationListResponse>(qs ? `notifications?${qs}` : 'notifications');
  }

  async markAsRead(id: string): Promise<NotificationItem> {
    return this.http.patch<NotificationItem>(`notifications/${id}/read`, {});
  }

  async markAllAsRead(): Promise<{ count: number }> {
    return this.http.patch<{ count: number }>('notifications/read-all', {});
  }
}
